<template>
  <div class="add-customer-container">
    <!-- Nagłówek -->
    <div class="page-header">
      <h2 class="page-title">👤 Dodaj klienta</h2>
      <p class="page-subtitle">Wprowadź dane klienta indywidualnego</p>
    </div>

    <!-- Formularz -->
    <div class="form-container">
      <form @submit.prevent="addContractor">
        <!-- Sekcja podstawowa -->
        <div class="form-section">
          <h3 class="section-title">📋 Dane podstawowe</h3>
          <div class="form-row">
            <div class="form-group full-width">
              <label class="form-label">Imię i nazwisko *</label>
              <input
                v-model="name"
                type="text"
                class="form-input"
                placeholder="Wprowadź imię i nazwisko"
              />
            </div>
          </div>
        </div>

        <!-- Sekcja kontakt -->
        <div class="form-section">
          <h3 class="section-title">📞 Dane kontaktowe</h3>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Email</label>
              <input
                v-model="email"
                type="email"
                class="form-input"
                placeholder="klient@example.com"
              />
            </div>
            <div class="form-group">
              <label class="form-label">Numer telefonu</label>
              <input
                v-model="phoneNumber"
                type="text"
                class="form-input"
                placeholder="+48 XXX XXX XXX"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group full-width">
              <label class="form-label">Adres</label>
              <input
                v-model="address"
                type="text"
                class="form-input"
                placeholder="Ulica, numer, kod pocztowy, miasto"
              />
            </div>
          </div>
        </div>

        <!-- Sekcja uwagi -->
        <div class="form-section">
          <h3 class="section-title">📝 Dodatkowe informacje</h3>
          <div class="form-row">
            <div class="form-group full-width">
              <label class="form-label">Uwagi</label>
              <textarea
                v-model="notice"
                class="form-textarea"
                rows="4"
                placeholder="Dodatkowe informacje o kliencie..."
              ></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Fixed footer -->
    <div class="form-footer">
      <div class="footer-left"></div>
      <div class="footer-center">
        <button class="btn-submit" @click="addContractor">
          <span class="submit-icon">✓</span>
          Dodaj klienta
        </button>
        <button class="btn-cancel" @click="$router.push('/contractors')">
          Anuluj
        </button>
      </div>
      <div class="footer-right"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      email: "",
      phoneNumber: "",
      address: "",
      notice: "",
      type: "customer",
    };
  },
  methods: {
    addContractor() {
      if (this.name == "") {
        this.$toast.error("Imię i nazwisko jest wymagane", {
          position: "top-right",
          duration: 3000,
        });
        return;
      }

      this.$store
        .dispatch("createCustomer", {
          name: this.name,
          email: this.email,
          phoneNumber: this.phoneNumber,
          address: this.address,
          notice: this.notice,
          type: "customer",
        })
        .then(() => {
          this.$toast.success("Klient został dodany pomyślnie", {
            position: "top-right",
            duration: 3000,
          });

          // Czyszczenie formularza
          this.name = "";
          this.email = "";
          this.phoneNumber = "";
          this.address = "";
          this.notice = "";

          // Przekierowanie po 1 sekundzie
          setTimeout(() => {
            this.$router.push("/contractors");
          }, 1000);
        })
        .catch((error) => {
          this.$toast.error("Błąd podczas dodawania klienta", {
            position: "top-right",
            duration: 3000,
          });
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
/* --- Kontener główny --- */
.add-customer-container {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
  padding-bottom: 120px;
}

/* --- Nagłówek --- */
.page-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 25px;
  text-align: center;
}

.page-title {
  margin: 0 0 8px 0;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-subtitle {
  margin: 0;
  font-size: 15px;
  color: #6c757d;
}

/* --- Formularz --- */
.form-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 30px;
  max-width: 900px;
  margin: 0 auto;
}

.form-section {
  margin-bottom: 35px;
  padding-bottom: 30px;
  border-bottom: 2px solid #f0f0f0;
}

.form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.form-input,
.form-textarea {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-textarea {
  resize: vertical;
  font-family: inherit;
}

/* --- Fixed footer --- */
.form-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 20px 40px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
}

.footer-left,
.footer-right {
  flex: 1;
}

.footer-center {
  display: flex;
  gap: 15px;
  align-items: center;
}

.btn-submit {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.5);
}

.submit-icon {
  font-size: 18px;
}

.btn-cancel {
  background: transparent;
  color: #718096;
  border: none;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel:hover {
  color: #2d3748;
  background: #f7fafc;
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .add-customer-container {
    padding: 15px;
  }

  .page-header {
    padding: 20px;
  }

  .page-title {
    font-size: 24px;
  }

  .form-container {
    padding: 20px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .form-footer {
    flex-direction: column;
    padding: 15px 20px;
    gap: 10px;
  }

  .footer-left,
  .footer-right {
    display: none;
  }

  .footer-center {
    flex-direction: column;
    width: 100%;
  }

  .btn-submit,
  .btn-cancel {
    width: 100%;
    justify-content: center;
  }
}
</style>